// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__cQLlJ","badge":"Skills_badge__ecEfz","study":"Skills_study__AYUcx","study_title":"Skills_study_title__eHxLs","study_icons":"Skills_study_icons__tbcad"};